import EducationCard from "../EducationCard";
import videoIcon from "../../icons/video.svg";
import articleIcon from "../../icons/articles.svg";
import downloadIcon from "../../icons/download.svg";
import youtubeIcon from "../../icons/integration.svg";
import courseIcon from "../../icons/courses.svg";
import { useInternationalizedItems } from "../../custom-hooks/useInternationalizedItems";
import { CardSize } from "../../types/constants";

const iconMap: Record<string, string> = {
    video: videoIcon,
    article: articleIcon,
    download: downloadIcon,
    integration: youtubeIcon,
    course: courseIcon,
};

type Card = {
    title: string;
    text: string;
    icon: string;
    stats: string;
};

export default function EducationRightPanel() {
    const cards = useInternationalizedItems<Card[]>({
        key: "home.educationCards",
    });

    return (
        <div className="flex flex-col gap-[15px] lap:gap-[20px] w-full md:w-full lap:w-[458px] xl:w-[582px] lg:w-[630px]">
            <div className="flex flex-col md:flex-wrap md:flex-row md:justify-between gap-[15px] lap:gap-[20px] w-full lap:w-[582px] lg:w-[630px]">
                {cards.map((card, index) => (
                    <EducationCard
                        key={index}
                        title={card.title}
                        text={card.text}
                        icon={iconMap[card.icon]}
                        stats={card.stats}
                        size={index < 4 ? CardSize.SMALL : CardSize.LARGE}
                    />
                ))}
            </div>
        </div>
    );
}
